import React, { Component } from "react";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import "./table.scss";
import { Waypoint } from "react-waypoint";

class Table extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isInViewport: false,
    };

    this.handleEnter = this.handleEnter.bind(this);
    this.handleLeave = this.handleLeave.bind(this);
  }

  handleEnter() {
    if (!this.state.isInViewport) {
      this.setState({
        isInViewport: true,
      });
    }
  }

  handleLeave() {
    if (this.state.isInViewport) {
      this.setState({
        isInViewport: false,
      });
    }
  }

  render() {
    let el;
    if (typeof document !== "undefined") {
      el = document.createElement("html");
      el.innerHTML = this.props.details.kenticoElements.table.value;
      const rows = el.querySelectorAll("table tr");
      if (rows.length) {
        let rowsArray = Array.from(rows);
        rowsArray.map((row, index) => {
          if (row.children.length) {
            let isHeader = false;
            let cellsArray = Array.from(row.children);
            cellsArray.map((cell, index) => {
              if (cell.children.length) {
                if (cell.children[0].tagName == "STRONG" || isHeader) {
                  cell.classList.add("header-cell");
                  if (index == 0) {
                    isHeader = true;
                  }
                }
                if (cell.children[0].tagName == "EM") {
                  cell.classList.add("highlight-cell");
                }
              }
            });
          }
        });
      }
    }

    const layoutOptions = this.props.details.kenticoElements.layout_options.value;
    let stripedRows;
    let flipPhone;
    Object.keys(layoutOptions).map((key, index) => {
      if (layoutOptions[key].codename === "striped_rows") {
        stripedRows = true;
      }
      if (layoutOptions[key].codename === "recommend_flipping_phone") {
        flipPhone = true;
      }
    });

    return (
      <Waypoint onEnter={this.handleEnter} onLeave={this.handleLeave}>
        <section
          className={`c-component table table--${
            this.props.details.kenticoElements.style.value[0]
              ? this.props.details.kenticoElements.style.value[0].codename
              : "grey"
          } ${stripedRows ? "table--striped" : ""} ${flipPhone ? "table--flip" : ""} ${
            this.state.isInViewport ? "table--visible" : ""
          }`}
        >
          {this.props.details.kenticoElements.table_header.value !== "" ? (
            <h3 className="table__header">
              {this.props.details.kenticoElements.table_header.value}
            </h3>
          ) : (
            ""
          )}
          {el.querySelectorAll("table")[0]
            ? parse(el.querySelectorAll("table")[0].outerHTML)
            : ""}
          {this.props.details.kenticoElements.caption_b2a355e.value !== "<p><br></p>" ? (
            <div className="table__caption">
              {parse(this.props.details.kenticoElements.caption_b2a355e.value)}
            </div>
          ) : (
            ""
          )}
        </section>
      </Waypoint>
    );
  }
}

Table.propTypes = {
  codename: PropTypes.string,
  details: PropTypes.object,
  chapterColor: PropTypes.string,
};

export default Table;
